import React from 'react';
import Input from '../../../components/UI/Input';
import Modal from '../../../components/UI/Modal';
import { Row, Col } from 'react-bootstrap';

const UpdateCategoriesModal = (props) => {
    const {
        show,
        handleClose,
        modalTitle,
        size,
        expandedArray,
        checkedArray,
        handleCategoryInput,
        categoryList,
        onSubmit
    } = props;

    const renderCategoryRow = (item, index, type) => {
        return (
            <Row
                key={`${type}_${item.value || item._id || index}`}
                style={{
                    marginBottom: 16,
                    paddingBottom: 14,
                    borderBottom: '1px solid rgba(0,0,0,.08)'
                }}
            >
                <Col md={3}>
                    <p>Переименовать</p>
                    <Input
                        value={item.name}
                        placeholder="Category Name"
                        onChange={(e) => handleCategoryInput('name', e.target.value, index, type)}
                    />
                </Col>

                <Col md={3}>
                    <p>Изменить категорию</p>
                    <select
                        className="form-control"
                        value={item.parentId || ''}
                        onChange={(e) => handleCategoryInput('parentId', e.target.value, index, type)}
                    >
                        <option value="">Без родительской категории</option>
                        {categoryList.map(option =>
                            <option key={option.value} value={option.value}>
                                {option.name}
                            </option>
                        )}
                    </select>
                </Col>

                <Col md={3}>
                    <p>Расчёт цены</p>
                    <select
                        className="form-control"
                        value={item.priceCalc || 'piece'}
                        onChange={(e) => handleCategoryInput('priceCalc', e.target.value, index, type)}
                    >
                        <option value="piece">Цена за штуку</option>
                        <option value="linearMeter">Цена за погонный метр</option>
                    </select>
                </Col>

                <Col md={3}>
                    <p>Редактор поверхности</p>

                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            minHeight: 38,
                            margin: 0,
                            cursor: 'pointer',
                            fontSize: 14
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={item.surfaceEditorEnabled === true}
                            onChange={(e) => handleCategoryInput(
                                'surfaceEditorEnabled',
                                e.target.checked,
                                index,
                                type
                            )}
                        />

                        <span>Разрешить</span>
                    </label>

                    <div
                        style={{
                            marginTop: 4,
                            fontSize: 12,
                            lineHeight: 1.35,
                            color: '#777'
                        }}
                    >
                        Для товаров этой категории можно будет открывать 2D-режим размещения текста, фото и других элементов на поверхности.
                    </div>
                </Col>
            </Row>
        );
    };

    return (
        <Modal
            show={show}
            handleClose={handleClose}
            onSubmit={onSubmit}
            modalTitle={modalTitle}
            size={size}
        >
            {
                expandedArray.length > 0 &&
                expandedArray.map((item, index) => renderCategoryRow(item, index, 'expanded'))
            }

            {
                checkedArray.length > 0 &&
                checkedArray.map((item, index) => renderCategoryRow(item, index, 'checked'))
            }
        </Modal>
    );
};

export default UpdateCategoriesModal;